import { accountPreferenceQuery, accountPreferencesQuery } from 'api/account'
import { doGraphqlRequest } from 'ducks/requests'
import { FETCH_ACCOUNT_PREFERENCES, FETCH_ACCOUNT_PREFERENCE } from '../types'

// eslint-disable-next-line no-unused-vars
export const doFetchAccountPreferences = (options = {}) => dispatch => {
  return dispatch(
    doGraphqlRequest(FETCH_ACCOUNT_PREFERENCES, accountPreferencesQuery)
  )
}

export const doFetchAccountPreference = (
  preference,
  // eslint-disable-next-line no-unused-vars
  options = {}
) => dispatch => {
  return dispatch(
    doGraphqlRequest(
      FETCH_ACCOUNT_PREFERENCE,
      accountPreferenceQuery(preference)
    )
  )
}
